module.exports = __webpack_public_path__ + "images/petal_grey_bg.cd904834.svg";